import request from "@/utils/request";

export function post(data) {
	return request({
		url: "",
		method: "post",
		data,
	});
}
